<app-table
  [elements]="campaigns"
  [cols]="columns"
  [lazy]="false"
  [defaultRows]="25"
  [sortField]="'_sortOrder'"
  [sortOrder]="-1"
  [modelName]="'campanhas'"
  [actionButtons]="actionButtons"
  addLabel="Nova Campanha"
  [addButtonRouterLink]="'new'"
  [dropdownFilters]="dropdownFilters"
></app-table>
